import styled from "styled-components";

export  const LoanCalculatorWrapper = styled.div`
margin-top: 20px;
gap: 24px;
&>div{
    flex: 1 1 45%;
    min-width: 0;
}
.calcInfo{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 28px;
    background: linear-gradient(155deg, #1C2634 0%, #20392a 55%, #2f6d22 100%);
    margin-right: 4px;
    padding: 36px 32px;
    color: #fff;
    border-radius: 18px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 12px 32px rgba(28,38,52,0.22);
    &::before {
        content: '';
        position: absolute;
        top: -60px; right: -60px;
        width: 220px; height: 220px;
        background: radial-gradient(circle, rgba(109,208,90,0.40), transparent 70%);
        border-radius: 50%;
        pointer-events: none;
    }
    &::after {
        content: '';
        position: absolute;
        bottom: -80px; left: -70px;
        width: 200px; height: 200px;
        background: radial-gradient(circle, rgba(80,149,64,0.28), transparent 70%);
        border-radius: 50%;
        pointer-events: none;
    }
    .calcInfo__top{
        position: relative;
        z-index: 1;
        .eyebrow{
            display: inline-block;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 1.5px;
            text-transform: uppercase;
            color: #6dd05a;
            background: rgba(109,208,90,0.12);
            border: 1px solid rgba(109,208,90,0.30);
            padding: 6px 14px;
            border-radius: 999px;
            margin-bottom: 18px;
        }
        .headline{
            font-size: 30px;
            line-height: 1.15;
            font-weight: 800;
            letter-spacing: -0.5px;
            color: #fff;
            margin: 0 0 14px 0;
        }
        .calcLead{
            font-size: 15px;
            line-height: 1.7;
            font-weight: 500;
            color: #cfe0ca;
            max-width: 92%;
        }
    }
    .features{
        position: relative;
        z-index: 1;
        list-style: none;
        display: flex;
        flex-direction: column;
        gap: 14px;
        margin: 0;
        padding: 0;
        li{
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 14.5px;
            font-weight: 500;
            color: #eaf3e7;
            svg{
                flex-shrink: 0;
                color: #1C2634;
                background: #6dd05a;
                border-radius: 50%;
                padding: 4px;
                box-shadow: 0 4px 10px rgba(109,208,90,0.35);
            }
        }
    }
}

.selectLoanPurpose{
  padding: 11px !important;
  height: 40px !important;
}
.calcForm{
    display: flex;
    flex-direction: column;
    gap: 12px;

    .box{
        padding: 20px 24px;
        background: linear-gradient(145deg, #20303f 0%, #1C2634 100%);
        border: 1px solid rgba(109,208,90,0.14);
        box-shadow: 0 6px 18px rgba(28,38,52,0.14);
        border-radius: 16px;
        min-height: 100px;
        color: #fff;
        transition: border-color 0.25s, box-shadow 0.25s, transform 0.25s;
        &:hover{
            border-color: rgba(109,208,90,0.40);
            box-shadow: 0 10px 26px rgba(28,38,52,0.22);
            transform: translateY(-2px);
        }
        h2{
            color: #fff;
            font-size: 15px;
            font-weight: 600;
            letter-spacing: 0.2px;
            margin-bottom: 14px;
        }
        &>div{
            gap: 12px;
            .value{
              font-size: 22px;
              font-weight: 800;
              color: #6dd05a;
              letter-spacing: -0.3px;
            }
        }
    }
    .cards-cal{
        display: flex;
        gap: 12px;
      .card-cal{
      background: #fff;
      border: 1px solid #e2efdd;
      box-shadow: 0 4px 16px rgba(80,149,64,0.10);
      border-radius: 16px;
      padding: 18px 10px;
      text-align: center;
      flex: 1 1 30%;
      transition: transform 0.25s, box-shadow 0.25s;
      &:hover{
        transform: translateY(-2px);
        box-shadow: 0 8px 22px rgba(80,149,64,0.18);
      }
      img{
        height: 38px;
        text-align: center;
        margin-bottom: 12px;
        padding: 8px;
        background: #f0f7ed;
        border-radius: 12px;
        box-sizing: content-box;
      }
      h3{
        font-size: 11px;
        letter-spacing: 0.8px;
        text-transform: uppercase;
        color: #509540;
        font-weight: 700;
        margin-bottom: 6px;
      }
      h2{
        font-size: 19px;
        color: #1C2634;
        font-weight: 800;
      }
      }
    }
}

/* Tablet & below — stack the two columns */
@media only screen and (max-width: 992px){
  flex-direction: column;
  &>div{
    flex: 1 1 100%;
    width: 100%;
  }
  .calcInfo{
    margin-right: 0;
  }
  .calcForm{
    margin-inline: auto;
    width: 100%;
  }
}

@media only screen and (max-width: 768px){
  margin-top: 12px;
  gap: 16px;
  .calcInfo{
    padding: 26px 22px;
    gap: 22px;
    .calcInfo__top{
      .headline{ font-size: 24px; }
      .calcLead{ font-size: 14px; max-width: 100%; }
    }
    .features li{ font-size: 13.5px; }
  }
  .calcForm{
    gap: 10px;
    .box{
      padding: 18px 18px;
      h2{ font-size: 15px; }
      &>div .value{ font-size: 18px; }
    }
  }
}

/* Phones — keep the two summary cards side-by-side but compact */
@media only screen and (max-width: 480px){
  .calcForm{
    .cards-cal{
      gap: 10px;
      .card-cal{
        padding: 14px 8px;
        img{ height: 34px; }
        h3{ font-size: 11px; }
        h2{ font-size: 15px; }
      }
    }
  }
}

`;